// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.finoa",
    name: "FinoaConnect",
    homepage: "https://app.finoa.io/",
    image_id: "b7a0c6fe-10bd-423c-6aa5-0637bd2b9900",
    app: {
        browser: "https://app.finoa.io/",
        ios: "https://apps.apple.com/us/app/finoa-2fa/id1484058524",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "io.finoa",
    mobile: {
        native: null,
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map